<template>
    <a
        @click="$emit('input', !value)"
        data-toggle="collapse"
        :href="`#${collapsableId}`"
    >
        <i class="fas fa-plus" v-if="value"></i>
        <i class="fas fa-minus" v-else></i>
    </a>
</template>

<script>
export default {
    name: 'CollapseButton',

    props: {
        collapsableId: {
            required: true,
            type: String,
        },
        value: {
            default: true,
            required: false,
            type: Boolean,
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Utility/Buttons/CollapseButton.vue